import React from "react";
import {useRouteMatch, useLocation} from "react-router-dom"

const NotFound = (props) => {
    const match = useRouteMatch();
    const location = useLocation();
    return <div>Page not Found: {location.pathname} (Path: {match.path})</div>
};
export default NotFound
